/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as AppOnlyRouteImport } from './routes/_appOnly'
import { Route as HostsHostCodeRouteImport } from './routes/hosts/$hostCode'
import { Route as AppOnlyAuthenticatedRouteImport } from './routes/_appOnly/_authenticated'
import { Route as AppOnlyLoginIndexRouteImport } from './routes/_appOnly/login/index'
import { Route as AppOnlyAuthenticatedIndexRouteImport } from './routes/_appOnly/_authenticated/index'
import { Route as SpacesSpaceIdGuestRouteImport } from './routes/spaces/$spaceId/guest'
import { Route as SpacesSpaceIdGuestIndexRouteImport } from './routes/spaces/$spaceId/guest/index'
import { Route as AppOnlyAuthenticatedSignUpIndexRouteImport } from './routes/_appOnly/_authenticated/sign-up/index'
import { Route as AppOnlyAuthenticatedMyPageIndexRouteImport } from './routes/_appOnly/_authenticated/my-page/index'
import { Route as AppOnlyAuthenticatedHomeIndexRouteImport } from './routes/_appOnly/_authenticated/home/index'
import { Route as AppOnlyAuthenticatedCreateSpaceIndexRouteImport } from './routes/_appOnly/_authenticated/create-space/index'
import { Route as AppOnlyAuthenticatedCreateExhibitionIndexRouteImport } from './routes/_appOnly/_authenticated/create-exhibition/index'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId'
import { Route as AppOnlyAuthenticatedSignUpCompleteRouteImport } from './routes/_appOnly/_authenticated/sign-up/complete'
import { Route as AppOnlyAuthenticatedMyPageTermsRouteImport } from './routes/_appOnly/_authenticated/my-page/terms'
import { Route as AppOnlyAuthenticatedMyPageEditRouteImport } from './routes/_appOnly/_authenticated/my-page/edit'
import { Route as SpacesSpaceIdGuestGuestbookIndexRouteImport } from './routes/spaces/$spaceId/guest/guestbook/index'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdIndexRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/index'
import { Route as SpacesSpaceIdGuestGuestbookWriteRouteImport } from './routes/spaces/$spaceId/guest/guestbook/write'
import { Route as SpacesSpaceIdGuestGuestbookGuestbookIdRouteImport } from './routes/spaces/$spaceId/guest/guestbook/$guestbookId'
import { Route as SpacesSpaceIdGuestArtworksArtworkIdRouteImport } from './routes/spaces/$spaceId/guest/artworks/$artworkId'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/guestbook/index'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdEditIndexRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/edit/index'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/create-product/index'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/guestbook/$guestbookId'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/index'
import { Route as AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRouteImport } from './routes/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/edit'

const LandingRoute = LandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOnlyRoute = AppOnlyRouteImport.update({
  id: '/_appOnly',
  getParentRoute: () => rootRouteImport,
} as any)
const HostsHostCodeRoute = HostsHostCodeRouteImport.update({
  id: '/hosts/$hostCode',
  path: '/hosts/$hostCode',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOnlyAuthenticatedRoute = AppOnlyAuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => AppOnlyRoute,
} as any)
const AppOnlyLoginIndexRoute = AppOnlyLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AppOnlyRoute,
} as any)
const AppOnlyAuthenticatedIndexRoute =
  AppOnlyAuthenticatedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const SpacesSpaceIdGuestRoute = SpacesSpaceIdGuestRouteImport.update({
  id: '/spaces/$spaceId/guest',
  path: '/spaces/$spaceId/guest',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesSpaceIdGuestIndexRoute = SpacesSpaceIdGuestIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SpacesSpaceIdGuestRoute,
} as any)
const AppOnlyAuthenticatedSignUpIndexRoute =
  AppOnlyAuthenticatedSignUpIndexRouteImport.update({
    id: '/sign-up/',
    path: '/sign-up/',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedMyPageIndexRoute =
  AppOnlyAuthenticatedMyPageIndexRouteImport.update({
    id: '/my-page/',
    path: '/my-page/',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedHomeIndexRoute =
  AppOnlyAuthenticatedHomeIndexRouteImport.update({
    id: '/home/',
    path: '/home/',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedCreateSpaceIndexRoute =
  AppOnlyAuthenticatedCreateSpaceIndexRouteImport.update({
    id: '/create-space/',
    path: '/create-space/',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedCreateExhibitionIndexRoute =
  AppOnlyAuthenticatedCreateExhibitionIndexRouteImport.update({
    id: '/create-exhibition/',
    path: '/create-exhibition/',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdRoute =
  AppOnlyAuthenticatedSpacesSpaceIdRouteImport.update({
    id: '/spaces/$spaceId',
    path: '/spaces/$spaceId',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedSignUpCompleteRoute =
  AppOnlyAuthenticatedSignUpCompleteRouteImport.update({
    id: '/sign-up/complete',
    path: '/sign-up/complete',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedMyPageTermsRoute =
  AppOnlyAuthenticatedMyPageTermsRouteImport.update({
    id: '/my-page/terms',
    path: '/my-page/terms',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const AppOnlyAuthenticatedMyPageEditRoute =
  AppOnlyAuthenticatedMyPageEditRouteImport.update({
    id: '/my-page/edit',
    path: '/my-page/edit',
    getParentRoute: () => AppOnlyAuthenticatedRoute,
  } as any)
const SpacesSpaceIdGuestGuestbookIndexRoute =
  SpacesSpaceIdGuestGuestbookIndexRouteImport.update({
    id: '/guestbook/',
    path: '/guestbook/',
    getParentRoute: () => SpacesSpaceIdGuestRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdIndexRoute =
  AppOnlyAuthenticatedSpacesSpaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)
const SpacesSpaceIdGuestGuestbookWriteRoute =
  SpacesSpaceIdGuestGuestbookWriteRouteImport.update({
    id: '/guestbook/write',
    path: '/guestbook/write',
    getParentRoute: () => SpacesSpaceIdGuestRoute,
  } as any)
const SpacesSpaceIdGuestGuestbookGuestbookIdRoute =
  SpacesSpaceIdGuestGuestbookGuestbookIdRouteImport.update({
    id: '/guestbook/$guestbookId',
    path: '/guestbook/$guestbookId',
    getParentRoute: () => SpacesSpaceIdGuestRoute,
  } as any)
const SpacesSpaceIdGuestArtworksArtworkIdRoute =
  SpacesSpaceIdGuestArtworksArtworkIdRouteImport.update({
    id: '/artworks/$artworkId',
    path: '/artworks/$artworkId',
    getParentRoute: () => SpacesSpaceIdGuestRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute =
  AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRouteImport.update({
    id: '/guestbook/',
    path: '/guestbook/',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute =
  AppOnlyAuthenticatedSpacesSpaceIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute =
  AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRouteImport.update({
    id: '/create-product/',
    path: '/create-product/',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute =
  AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRouteImport.update({
    id: '/guestbook/$guestbookId',
    path: '/guestbook/$guestbookId',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute =
  AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRouteImport.update({
    id: '/artworks/$artworkId/',
    path: '/artworks/$artworkId/',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)
const AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute =
  AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRouteImport.update({
    id: '/artworks/$artworkId/edit',
    path: '/artworks/$artworkId/edit',
    getParentRoute: () => AppOnlyAuthenticatedSpacesSpaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppOnlyAuthenticatedIndexRoute
  '/landing': typeof LandingRoute
  '/hosts/$hostCode': typeof HostsHostCodeRoute
  '/spaces/$spaceId/guest': typeof SpacesSpaceIdGuestRouteWithChildren
  '/login/': typeof AppOnlyLoginIndexRoute
  '/my-page/edit': typeof AppOnlyAuthenticatedMyPageEditRoute
  '/my-page/terms': typeof AppOnlyAuthenticatedMyPageTermsRoute
  '/sign-up/complete': typeof AppOnlyAuthenticatedSignUpCompleteRoute
  '/spaces/$spaceId': typeof AppOnlyAuthenticatedSpacesSpaceIdRouteWithChildren
  '/create-exhibition/': typeof AppOnlyAuthenticatedCreateExhibitionIndexRoute
  '/create-space/': typeof AppOnlyAuthenticatedCreateSpaceIndexRoute
  '/home/': typeof AppOnlyAuthenticatedHomeIndexRoute
  '/my-page/': typeof AppOnlyAuthenticatedMyPageIndexRoute
  '/sign-up/': typeof AppOnlyAuthenticatedSignUpIndexRoute
  '/spaces/$spaceId/guest/': typeof SpacesSpaceIdGuestIndexRoute
  '/spaces/$spaceId/guest/artworks/$artworkId': typeof SpacesSpaceIdGuestArtworksArtworkIdRoute
  '/spaces/$spaceId/guest/guestbook/$guestbookId': typeof SpacesSpaceIdGuestGuestbookGuestbookIdRoute
  '/spaces/$spaceId/guest/guestbook/write': typeof SpacesSpaceIdGuestGuestbookWriteRoute
  '/spaces/$spaceId/': typeof AppOnlyAuthenticatedSpacesSpaceIdIndexRoute
  '/spaces/$spaceId/guest/guestbook/': typeof SpacesSpaceIdGuestGuestbookIndexRoute
  '/spaces/$spaceId/guestbook/$guestbookId': typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute
  '/spaces/$spaceId/create-product/': typeof AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute
  '/spaces/$spaceId/edit/': typeof AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute
  '/spaces/$spaceId/guestbook/': typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute
  '/spaces/$spaceId/artworks/$artworkId/edit': typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute
  '/spaces/$spaceId/artworks/$artworkId/': typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppOnlyAuthenticatedIndexRoute
  '/landing': typeof LandingRoute
  '/hosts/$hostCode': typeof HostsHostCodeRoute
  '/login': typeof AppOnlyLoginIndexRoute
  '/my-page/edit': typeof AppOnlyAuthenticatedMyPageEditRoute
  '/my-page/terms': typeof AppOnlyAuthenticatedMyPageTermsRoute
  '/sign-up/complete': typeof AppOnlyAuthenticatedSignUpCompleteRoute
  '/create-exhibition': typeof AppOnlyAuthenticatedCreateExhibitionIndexRoute
  '/create-space': typeof AppOnlyAuthenticatedCreateSpaceIndexRoute
  '/home': typeof AppOnlyAuthenticatedHomeIndexRoute
  '/my-page': typeof AppOnlyAuthenticatedMyPageIndexRoute
  '/sign-up': typeof AppOnlyAuthenticatedSignUpIndexRoute
  '/spaces/$spaceId/guest': typeof SpacesSpaceIdGuestIndexRoute
  '/spaces/$spaceId/guest/artworks/$artworkId': typeof SpacesSpaceIdGuestArtworksArtworkIdRoute
  '/spaces/$spaceId/guest/guestbook/$guestbookId': typeof SpacesSpaceIdGuestGuestbookGuestbookIdRoute
  '/spaces/$spaceId/guest/guestbook/write': typeof SpacesSpaceIdGuestGuestbookWriteRoute
  '/spaces/$spaceId': typeof AppOnlyAuthenticatedSpacesSpaceIdIndexRoute
  '/spaces/$spaceId/guest/guestbook': typeof SpacesSpaceIdGuestGuestbookIndexRoute
  '/spaces/$spaceId/guestbook/$guestbookId': typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute
  '/spaces/$spaceId/create-product': typeof AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute
  '/spaces/$spaceId/edit': typeof AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute
  '/spaces/$spaceId/guestbook': typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute
  '/spaces/$spaceId/artworks/$artworkId/edit': typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute
  '/spaces/$spaceId/artworks/$artworkId': typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_appOnly': typeof AppOnlyRouteWithChildren
  '/landing': typeof LandingRoute
  '/_appOnly/_authenticated': typeof AppOnlyAuthenticatedRouteWithChildren
  '/hosts/$hostCode': typeof HostsHostCodeRoute
  '/spaces/$spaceId/guest': typeof SpacesSpaceIdGuestRouteWithChildren
  '/_appOnly/_authenticated/': typeof AppOnlyAuthenticatedIndexRoute
  '/_appOnly/login/': typeof AppOnlyLoginIndexRoute
  '/_appOnly/_authenticated/my-page/edit': typeof AppOnlyAuthenticatedMyPageEditRoute
  '/_appOnly/_authenticated/my-page/terms': typeof AppOnlyAuthenticatedMyPageTermsRoute
  '/_appOnly/_authenticated/sign-up/complete': typeof AppOnlyAuthenticatedSignUpCompleteRoute
  '/_appOnly/_authenticated/spaces/$spaceId': typeof AppOnlyAuthenticatedSpacesSpaceIdRouteWithChildren
  '/_appOnly/_authenticated/create-exhibition/': typeof AppOnlyAuthenticatedCreateExhibitionIndexRoute
  '/_appOnly/_authenticated/create-space/': typeof AppOnlyAuthenticatedCreateSpaceIndexRoute
  '/_appOnly/_authenticated/home/': typeof AppOnlyAuthenticatedHomeIndexRoute
  '/_appOnly/_authenticated/my-page/': typeof AppOnlyAuthenticatedMyPageIndexRoute
  '/_appOnly/_authenticated/sign-up/': typeof AppOnlyAuthenticatedSignUpIndexRoute
  '/spaces/$spaceId/guest/': typeof SpacesSpaceIdGuestIndexRoute
  '/spaces/$spaceId/guest/artworks/$artworkId': typeof SpacesSpaceIdGuestArtworksArtworkIdRoute
  '/spaces/$spaceId/guest/guestbook/$guestbookId': typeof SpacesSpaceIdGuestGuestbookGuestbookIdRoute
  '/spaces/$spaceId/guest/guestbook/write': typeof SpacesSpaceIdGuestGuestbookWriteRoute
  '/_appOnly/_authenticated/spaces/$spaceId/': typeof AppOnlyAuthenticatedSpacesSpaceIdIndexRoute
  '/spaces/$spaceId/guest/guestbook/': typeof SpacesSpaceIdGuestGuestbookIndexRoute
  '/_appOnly/_authenticated/spaces/$spaceId/guestbook/$guestbookId': typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute
  '/_appOnly/_authenticated/spaces/$spaceId/create-product/': typeof AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute
  '/_appOnly/_authenticated/spaces/$spaceId/edit/': typeof AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute
  '/_appOnly/_authenticated/spaces/$spaceId/guestbook/': typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute
  '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/edit': typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute
  '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/': typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/landing'
    | '/hosts/$hostCode'
    | '/spaces/$spaceId/guest'
    | '/login/'
    | '/my-page/edit'
    | '/my-page/terms'
    | '/sign-up/complete'
    | '/spaces/$spaceId'
    | '/create-exhibition/'
    | '/create-space/'
    | '/home/'
    | '/my-page/'
    | '/sign-up/'
    | '/spaces/$spaceId/guest/'
    | '/spaces/$spaceId/guest/artworks/$artworkId'
    | '/spaces/$spaceId/guest/guestbook/$guestbookId'
    | '/spaces/$spaceId/guest/guestbook/write'
    | '/spaces/$spaceId/'
    | '/spaces/$spaceId/guest/guestbook/'
    | '/spaces/$spaceId/guestbook/$guestbookId'
    | '/spaces/$spaceId/create-product/'
    | '/spaces/$spaceId/edit/'
    | '/spaces/$spaceId/guestbook/'
    | '/spaces/$spaceId/artworks/$artworkId/edit'
    | '/spaces/$spaceId/artworks/$artworkId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/landing'
    | '/hosts/$hostCode'
    | '/login'
    | '/my-page/edit'
    | '/my-page/terms'
    | '/sign-up/complete'
    | '/create-exhibition'
    | '/create-space'
    | '/home'
    | '/my-page'
    | '/sign-up'
    | '/spaces/$spaceId/guest'
    | '/spaces/$spaceId/guest/artworks/$artworkId'
    | '/spaces/$spaceId/guest/guestbook/$guestbookId'
    | '/spaces/$spaceId/guest/guestbook/write'
    | '/spaces/$spaceId'
    | '/spaces/$spaceId/guest/guestbook'
    | '/spaces/$spaceId/guestbook/$guestbookId'
    | '/spaces/$spaceId/create-product'
    | '/spaces/$spaceId/edit'
    | '/spaces/$spaceId/guestbook'
    | '/spaces/$spaceId/artworks/$artworkId/edit'
    | '/spaces/$spaceId/artworks/$artworkId'
  id:
    | '__root__'
    | '/_appOnly'
    | '/landing'
    | '/_appOnly/_authenticated'
    | '/hosts/$hostCode'
    | '/spaces/$spaceId/guest'
    | '/_appOnly/_authenticated/'
    | '/_appOnly/login/'
    | '/_appOnly/_authenticated/my-page/edit'
    | '/_appOnly/_authenticated/my-page/terms'
    | '/_appOnly/_authenticated/sign-up/complete'
    | '/_appOnly/_authenticated/spaces/$spaceId'
    | '/_appOnly/_authenticated/create-exhibition/'
    | '/_appOnly/_authenticated/create-space/'
    | '/_appOnly/_authenticated/home/'
    | '/_appOnly/_authenticated/my-page/'
    | '/_appOnly/_authenticated/sign-up/'
    | '/spaces/$spaceId/guest/'
    | '/spaces/$spaceId/guest/artworks/$artworkId'
    | '/spaces/$spaceId/guest/guestbook/$guestbookId'
    | '/spaces/$spaceId/guest/guestbook/write'
    | '/_appOnly/_authenticated/spaces/$spaceId/'
    | '/spaces/$spaceId/guest/guestbook/'
    | '/_appOnly/_authenticated/spaces/$spaceId/guestbook/$guestbookId'
    | '/_appOnly/_authenticated/spaces/$spaceId/create-product/'
    | '/_appOnly/_authenticated/spaces/$spaceId/edit/'
    | '/_appOnly/_authenticated/spaces/$spaceId/guestbook/'
    | '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/edit'
    | '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppOnlyRoute: typeof AppOnlyRouteWithChildren
  LandingRoute: typeof LandingRoute
  HostsHostCodeRoute: typeof HostsHostCodeRoute
  SpacesSpaceIdGuestRoute: typeof SpacesSpaceIdGuestRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/landing': {
      id: '/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_appOnly': {
      id: '/_appOnly'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppOnlyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hosts/$hostCode': {
      id: '/hosts/$hostCode'
      path: '/hosts/$hostCode'
      fullPath: '/hosts/$hostCode'
      preLoaderRoute: typeof HostsHostCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_appOnly/_authenticated': {
      id: '/_appOnly/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppOnlyAuthenticatedRouteImport
      parentRoute: typeof AppOnlyRoute
    }
    '/_appOnly/login/': {
      id: '/_appOnly/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AppOnlyLoginIndexRouteImport
      parentRoute: typeof AppOnlyRoute
    }
    '/_appOnly/_authenticated/': {
      id: '/_appOnly/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppOnlyAuthenticatedIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/spaces/$spaceId/guest': {
      id: '/spaces/$spaceId/guest'
      path: '/spaces/$spaceId/guest'
      fullPath: '/spaces/$spaceId/guest'
      preLoaderRoute: typeof SpacesSpaceIdGuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/$spaceId/guest/': {
      id: '/spaces/$spaceId/guest/'
      path: '/'
      fullPath: '/spaces/$spaceId/guest/'
      preLoaderRoute: typeof SpacesSpaceIdGuestIndexRouteImport
      parentRoute: typeof SpacesSpaceIdGuestRoute
    }
    '/_appOnly/_authenticated/sign-up/': {
      id: '/_appOnly/_authenticated/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof AppOnlyAuthenticatedSignUpIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/my-page/': {
      id: '/_appOnly/_authenticated/my-page/'
      path: '/my-page'
      fullPath: '/my-page/'
      preLoaderRoute: typeof AppOnlyAuthenticatedMyPageIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/home/': {
      id: '/_appOnly/_authenticated/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AppOnlyAuthenticatedHomeIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/create-space/': {
      id: '/_appOnly/_authenticated/create-space/'
      path: '/create-space'
      fullPath: '/create-space/'
      preLoaderRoute: typeof AppOnlyAuthenticatedCreateSpaceIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/create-exhibition/': {
      id: '/_appOnly/_authenticated/create-exhibition/'
      path: '/create-exhibition'
      fullPath: '/create-exhibition/'
      preLoaderRoute: typeof AppOnlyAuthenticatedCreateExhibitionIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId': {
      id: '/_appOnly/_authenticated/spaces/$spaceId'
      path: '/spaces/$spaceId'
      fullPath: '/spaces/$spaceId'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/sign-up/complete': {
      id: '/_appOnly/_authenticated/sign-up/complete'
      path: '/sign-up/complete'
      fullPath: '/sign-up/complete'
      preLoaderRoute: typeof AppOnlyAuthenticatedSignUpCompleteRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/my-page/terms': {
      id: '/_appOnly/_authenticated/my-page/terms'
      path: '/my-page/terms'
      fullPath: '/my-page/terms'
      preLoaderRoute: typeof AppOnlyAuthenticatedMyPageTermsRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/_appOnly/_authenticated/my-page/edit': {
      id: '/_appOnly/_authenticated/my-page/edit'
      path: '/my-page/edit'
      fullPath: '/my-page/edit'
      preLoaderRoute: typeof AppOnlyAuthenticatedMyPageEditRouteImport
      parentRoute: typeof AppOnlyAuthenticatedRoute
    }
    '/spaces/$spaceId/guest/guestbook/': {
      id: '/spaces/$spaceId/guest/guestbook/'
      path: '/guestbook'
      fullPath: '/spaces/$spaceId/guest/guestbook/'
      preLoaderRoute: typeof SpacesSpaceIdGuestGuestbookIndexRouteImport
      parentRoute: typeof SpacesSpaceIdGuestRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/'
      path: '/'
      fullPath: '/spaces/$spaceId/'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
    '/spaces/$spaceId/guest/guestbook/write': {
      id: '/spaces/$spaceId/guest/guestbook/write'
      path: '/guestbook/write'
      fullPath: '/spaces/$spaceId/guest/guestbook/write'
      preLoaderRoute: typeof SpacesSpaceIdGuestGuestbookWriteRouteImport
      parentRoute: typeof SpacesSpaceIdGuestRoute
    }
    '/spaces/$spaceId/guest/guestbook/$guestbookId': {
      id: '/spaces/$spaceId/guest/guestbook/$guestbookId'
      path: '/guestbook/$guestbookId'
      fullPath: '/spaces/$spaceId/guest/guestbook/$guestbookId'
      preLoaderRoute: typeof SpacesSpaceIdGuestGuestbookGuestbookIdRouteImport
      parentRoute: typeof SpacesSpaceIdGuestRoute
    }
    '/spaces/$spaceId/guest/artworks/$artworkId': {
      id: '/spaces/$spaceId/guest/artworks/$artworkId'
      path: '/artworks/$artworkId'
      fullPath: '/spaces/$spaceId/guest/artworks/$artworkId'
      preLoaderRoute: typeof SpacesSpaceIdGuestArtworksArtworkIdRouteImport
      parentRoute: typeof SpacesSpaceIdGuestRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/guestbook/': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/guestbook/'
      path: '/guestbook'
      fullPath: '/spaces/$spaceId/guestbook/'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/edit/': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/edit/'
      path: '/edit'
      fullPath: '/spaces/$spaceId/edit/'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdEditIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/create-product/': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/create-product/'
      path: '/create-product'
      fullPath: '/spaces/$spaceId/create-product/'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/guestbook/$guestbookId': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/guestbook/$guestbookId'
      path: '/guestbook/$guestbookId'
      fullPath: '/spaces/$spaceId/guestbook/$guestbookId'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/'
      path: '/artworks/$artworkId'
      fullPath: '/spaces/$spaceId/artworks/$artworkId/'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
    '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/edit': {
      id: '/_appOnly/_authenticated/spaces/$spaceId/artworks/$artworkId/edit'
      path: '/artworks/$artworkId/edit'
      fullPath: '/spaces/$spaceId/artworks/$artworkId/edit'
      preLoaderRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRouteImport
      parentRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRoute
    }
  }
}

interface AppOnlyAuthenticatedSpacesSpaceIdRouteChildren {
  AppOnlyAuthenticatedSpacesSpaceIdIndexRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdIndexRoute
  AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute
  AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute
  AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute
  AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute
  AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute
  AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute
}

const AppOnlyAuthenticatedSpacesSpaceIdRouteChildren: AppOnlyAuthenticatedSpacesSpaceIdRouteChildren =
  {
    AppOnlyAuthenticatedSpacesSpaceIdIndexRoute:
      AppOnlyAuthenticatedSpacesSpaceIdIndexRoute,
    AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute:
      AppOnlyAuthenticatedSpacesSpaceIdGuestbookGuestbookIdRoute,
    AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute:
      AppOnlyAuthenticatedSpacesSpaceIdCreateProductIndexRoute,
    AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute:
      AppOnlyAuthenticatedSpacesSpaceIdEditIndexRoute,
    AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute:
      AppOnlyAuthenticatedSpacesSpaceIdGuestbookIndexRoute,
    AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute:
      AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdEditRoute,
    AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute:
      AppOnlyAuthenticatedSpacesSpaceIdArtworksArtworkIdIndexRoute,
  }

const AppOnlyAuthenticatedSpacesSpaceIdRouteWithChildren =
  AppOnlyAuthenticatedSpacesSpaceIdRoute._addFileChildren(
    AppOnlyAuthenticatedSpacesSpaceIdRouteChildren,
  )

interface AppOnlyAuthenticatedRouteChildren {
  AppOnlyAuthenticatedIndexRoute: typeof AppOnlyAuthenticatedIndexRoute
  AppOnlyAuthenticatedMyPageEditRoute: typeof AppOnlyAuthenticatedMyPageEditRoute
  AppOnlyAuthenticatedMyPageTermsRoute: typeof AppOnlyAuthenticatedMyPageTermsRoute
  AppOnlyAuthenticatedSignUpCompleteRoute: typeof AppOnlyAuthenticatedSignUpCompleteRoute
  AppOnlyAuthenticatedSpacesSpaceIdRoute: typeof AppOnlyAuthenticatedSpacesSpaceIdRouteWithChildren
  AppOnlyAuthenticatedCreateExhibitionIndexRoute: typeof AppOnlyAuthenticatedCreateExhibitionIndexRoute
  AppOnlyAuthenticatedCreateSpaceIndexRoute: typeof AppOnlyAuthenticatedCreateSpaceIndexRoute
  AppOnlyAuthenticatedHomeIndexRoute: typeof AppOnlyAuthenticatedHomeIndexRoute
  AppOnlyAuthenticatedMyPageIndexRoute: typeof AppOnlyAuthenticatedMyPageIndexRoute
  AppOnlyAuthenticatedSignUpIndexRoute: typeof AppOnlyAuthenticatedSignUpIndexRoute
}

const AppOnlyAuthenticatedRouteChildren: AppOnlyAuthenticatedRouteChildren = {
  AppOnlyAuthenticatedIndexRoute: AppOnlyAuthenticatedIndexRoute,
  AppOnlyAuthenticatedMyPageEditRoute: AppOnlyAuthenticatedMyPageEditRoute,
  AppOnlyAuthenticatedMyPageTermsRoute: AppOnlyAuthenticatedMyPageTermsRoute,
  AppOnlyAuthenticatedSignUpCompleteRoute:
    AppOnlyAuthenticatedSignUpCompleteRoute,
  AppOnlyAuthenticatedSpacesSpaceIdRoute:
    AppOnlyAuthenticatedSpacesSpaceIdRouteWithChildren,
  AppOnlyAuthenticatedCreateExhibitionIndexRoute:
    AppOnlyAuthenticatedCreateExhibitionIndexRoute,
  AppOnlyAuthenticatedCreateSpaceIndexRoute:
    AppOnlyAuthenticatedCreateSpaceIndexRoute,
  AppOnlyAuthenticatedHomeIndexRoute: AppOnlyAuthenticatedHomeIndexRoute,
  AppOnlyAuthenticatedMyPageIndexRoute: AppOnlyAuthenticatedMyPageIndexRoute,
  AppOnlyAuthenticatedSignUpIndexRoute: AppOnlyAuthenticatedSignUpIndexRoute,
}

const AppOnlyAuthenticatedRouteWithChildren =
  AppOnlyAuthenticatedRoute._addFileChildren(AppOnlyAuthenticatedRouteChildren)

interface AppOnlyRouteChildren {
  AppOnlyAuthenticatedRoute: typeof AppOnlyAuthenticatedRouteWithChildren
  AppOnlyLoginIndexRoute: typeof AppOnlyLoginIndexRoute
}

const AppOnlyRouteChildren: AppOnlyRouteChildren = {
  AppOnlyAuthenticatedRoute: AppOnlyAuthenticatedRouteWithChildren,
  AppOnlyLoginIndexRoute: AppOnlyLoginIndexRoute,
}

const AppOnlyRouteWithChildren =
  AppOnlyRoute._addFileChildren(AppOnlyRouteChildren)

interface SpacesSpaceIdGuestRouteChildren {
  SpacesSpaceIdGuestIndexRoute: typeof SpacesSpaceIdGuestIndexRoute
  SpacesSpaceIdGuestArtworksArtworkIdRoute: typeof SpacesSpaceIdGuestArtworksArtworkIdRoute
  SpacesSpaceIdGuestGuestbookGuestbookIdRoute: typeof SpacesSpaceIdGuestGuestbookGuestbookIdRoute
  SpacesSpaceIdGuestGuestbookWriteRoute: typeof SpacesSpaceIdGuestGuestbookWriteRoute
  SpacesSpaceIdGuestGuestbookIndexRoute: typeof SpacesSpaceIdGuestGuestbookIndexRoute
}

const SpacesSpaceIdGuestRouteChildren: SpacesSpaceIdGuestRouteChildren = {
  SpacesSpaceIdGuestIndexRoute: SpacesSpaceIdGuestIndexRoute,
  SpacesSpaceIdGuestArtworksArtworkIdRoute:
    SpacesSpaceIdGuestArtworksArtworkIdRoute,
  SpacesSpaceIdGuestGuestbookGuestbookIdRoute:
    SpacesSpaceIdGuestGuestbookGuestbookIdRoute,
  SpacesSpaceIdGuestGuestbookWriteRoute: SpacesSpaceIdGuestGuestbookWriteRoute,
  SpacesSpaceIdGuestGuestbookIndexRoute: SpacesSpaceIdGuestGuestbookIndexRoute,
}

const SpacesSpaceIdGuestRouteWithChildren =
  SpacesSpaceIdGuestRoute._addFileChildren(SpacesSpaceIdGuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppOnlyRoute: AppOnlyRouteWithChildren,
  LandingRoute: LandingRoute,
  HostsHostCodeRoute: HostsHostCodeRoute,
  SpacesSpaceIdGuestRoute: SpacesSpaceIdGuestRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
